import React from 'react';
import { IoMdPhotos } from "react-icons/io";
import useCustomNavigate from '../../hooks/useCustomNavigate';
import { formatCurrencyUtil } from '../../Utils/localStorageUtils';

function ProjectCard({ _id,imageUrl, title,projectBuilder, price, size, location, status, photosCount }) {
   
    const {goTo} = useCustomNavigate()

    console.log("pricepriceprice",price)

   
    return (
        <div
        onClick={() => { goTo(`/project/${_id}`) }}
        className="max-w-[300px] min-w-[290px] max-h-[390px] h-[335px] rounded-[8px] overflow-hidden border border-gray-300 transition duration-300 hover:shadow-xl cursor-pointer group">
            <div className='w-full h-[150px] rounded-t-sm overflow-hidden relative'>
                <img 
                className="w-full h-full transition duration-300 transform group-hover:scale-110" 
                src={imageUrl} 
                alt="Property" 
                onError={(e)=>{e.target.src="https://cdn.staticmb.com/property/microsite/mbimages/01012868/projectspotlight-img.jpg"}}
                />
                {/* <div className="absolute bottom-2 rounded left-2 bg-[#303030] bg-opacity-70 text-white flex items-center p-1">
                    <IoMdPhotos className="text-xs mr-1" />
                    <span className="text-xs">{photosCount}</span>
                </div> */}
            </div>
            <div className="px-3 py-2 relative">

                <p className="text-[#303030] text-[18px] font-semibold mb-1 capitalize">
                {title || "Project Name Unavailable"}
                </p>
                <div className="font-normal text-sm text-[#606060] mb-2">
                  <p>by <span>{projectBuilder || "Builder Not Specified"}</span></p> 
                   <p className='capitalize'>{location || "Builder Not Specified"}</p> 
                </div>
                <p className="text-[#303030] text-sm pb-1">{size ? `${size} Flats` : "Size Unavailable"}</p>
                <p className="text-[#303030] font-semibold text-sm"> {formatCurrencyUtil(price)} <span className='text-[12px] text-[#606060]'>onwards</span> </p>
                <div className="transition duration-500 ease-in-out transform group-hover:translate-y-10 group-hover:opacity-0">
                    <span className="inline-block rounded-full py-1 text-xs font-normal text-[#606060] mr-2 mb-2">
                        Marketed By {projectBuilder}
                    </span>
                </div>
                <button className="absolute bottom-[-10px] left-3 right-3 bg-[#2b463c] text-white text-sm font-semibold py-1 rounded-full opacity-0 transition duration-300 ease-in-out transform group-hover:translate-y-[-12px] group-hover:opacity-100 w-[120px] px-1">
                    View Details
                </button>
            </div>
        </div>
    );
}

export default ProjectCard;
